module.exports = __webpack_public_path__ + "static/media/vacant-land.40d64003.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/vacant-land.svg
// module id = 540
// module chunks = 0